import { render, staticRenderFns } from "./UpdateShareLinkStatus.vue?vue&type=template&id=f1980674"
import script from "./UpdateShareLinkStatus.vue?vue&type=script&lang=js"
export * from "./UpdateShareLinkStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports